var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStepNumberTwo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 122,
    viewBox: "0 0 96 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.44 122V104.15L51.34 60.8C54.9667 57.5133 57.63 54.5666 59.33 51.96C61.03 49.3533 62.1633 46.9733 62.73 44.82C63.41 42.6666 63.75 40.6833 63.75 38.87C63.75 34.11 62.1067 30.4833 58.82 27.99C55.6467 25.3833 50.9433 24.08 44.71 24.08C39.7233 24.08 35.0767 25.0433 30.77 26.97C26.5767 28.8966 23.0067 31.9 20.06 35.98L0 23.06C4.53333 16.26 10.88 10.8766 19.04 6.90996C27.2 2.94329 36.6067 0.959961 47.26 0.959961C56.1 0.959961 63.8067 2.43329 70.38 5.37995C77.0667 8.21329 82.2233 12.2366 85.85 17.45C89.59 22.6633 91.46 28.8966 91.46 36.15C91.46 40.0033 90.95 43.8566 89.93 47.71C89.0233 51.45 87.0967 55.4166 84.15 59.61C81.3167 63.8033 77.1233 68.5066 71.57 73.72L33.49 109.59L28.22 99.56H95.37V122H5.44Z",
    fill: "url(#paint0_linear_61_1848)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_1848",
    x1: 49.9667,
    y1: 24,
    x2: 49.9667,
    y2: 145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepNumberTwo);
export default __webpack_public_path__ + "static/media/Step_number_two.1afc4bcc3b53fa48b24a952f44824668.svg";
export { ForwardRef as ReactComponent };